const PERMISSIONS = {
  CAN_EDIT_ACCOUNT: "UserEdit",
  CAN_VIEW_ACCOUNT: "UserView",
  CAN_EDIT_ORG: "OrganizationEdit",
  CAN_ADMIN_EDIT_ORG: "OrganizationAdminEdit",
  CAN_INVITE_USER: "UserInvite",
  CAN_VIEW_ADMIN: "UserAdminView",
  CAN_USE_ACCREDITATION: "UserAccreditation",
  CAN_VIEW_ORG_USERS: "OrganizationViewUsers",
  CAN_ASSIGN_MAIN: "CanAssignMain",
  CAN_ADD_DIGITAL_SIGNATURE: "UserAttachSign",
  CAN_ASSIGN_MANUAL_REVIEW: "CanAssignManualReview",
  CAN_ABORT_MANUAL_REVIEW: "CanAbortManualReview",
  CAN_CREATE_ACCREDITATION: "CanCreateAccreditation",
  CAN_EDIT_ACCREDITATION: "CanEdit",
  CAN_VIEW_ACCREDITATION: "CanView",
  CAN_SIGN_ACCREDITATION: "CanSign",
  CAN_REJECT_ACCREDITATION: "CanReject",
  CAN_SET_DEPARTMENT: "CanSetDepartment",
  CAN_WORK_WITH_ALL_USERS : "UserAdminUsers",
  CAN_CHANGE_DIRECTLY: "CanChangeStateDirectly",
  CAN_CHANGE_WITH_MODIFY: "CanChangeState",
  CAN_VIEW_LOTS: "LotView",
  CAN_ADMIN_VIEW_LOTS: "LotAdminView",
  CAN_ADMIN_VIEW_CONTRACTORS: "UserAdminOrganizations",
  CAN_ADD_TO_COMMISSION: "CanSetCommission",
  CAN_REMOVE_FROM_COMMISSION: "CanAbortCommission",
  CAN_CREATE_LOT: "LotEdit",
  CAN_DOWNLOAD_REDUCTION_SPECIFICATION: "RequestGetReductionData",

  CANNOT_SET_CATEGORIES: "IsMtsUser",
  USER_CANNOT_CREATE_ACCREDITATION: "IsMtsUser",
  IS_CUSTOMER_USER: "IsCustomerUser",
  IS_MAIN_CUSTOMER_USER: "IsMainCustomerUser",
  IS_MTS_USER: "IsMtsUser",

  CAN_EDIT_FULL_LOT: "CanEditFull",
  CAN_EDIT_LOT_PARTIALLY: "CanEditPartially",
  CAN_SEND_LOT_FOR_APPROVE: "CanSendToApprove",
  CAN_PUBLISH_LOT: "CanPublish",
  CAN_COPY_LOT: "CanCopy",
  CAN_CREATE_TENDER: "CanCreateTender",
  CAN_APPROVE_LOT: "CanApprove",
  CAN_DECLINE_LOT: "CanApprove",
  CAN_CANCEL_LOT: "CanCancel",
  CAN_MANUALLY_SAVE_LOT: "CanManualSaveChange",
  CAN_ADD_LOT_IN_FAVORITES: "CanAddFavorite",
  CAN_REMOVE_LOT_FROM_FAVORITES: "CanDeleteFavorite",
  CAN_DELETE_LOT: "CanDelete",
  CAN_VIEW_TENDERS: "TenderView",
  CAN_ADMIN_VIEW_TENDERS: "TenderAdminView",
  CAN_VIEW_PUBLIC_TENDERS: 'TenderViewPublic',
  CAN_EDIT_FULL_TENDER: "CanEditFull",
  CAN_EDIT_TENDER_PARTIALLY: 'CanEditPartially',
  CAN_MANUALLY_SAVE_TENDER: 'CanManualSaveChange',
  CAN_CHANGE_TENDER_ORGANIZER: 'CanChangeOrganization',
  CAN_SEND_TENDER_FOR_APPROVAL: "CanSendToApprove",
  CAN_PUBLISH_TENDER: "CanPublish",
  CAN_APPROVE_TENDER: "CanApprove",
  CAN_REJECT_TENDER: "CanDecline",

  CAN_SEE_PUBLIC_LOT_STATISTICS: "CanStatistics",
  CAN_SEE_PUBLIC_LOT_COMMISSION: "CanCommission",
  CAN_SEE_PUBLIC_LOT_ACTUAL_RECEIVING_REQUESTS_DURATION: "CanGettingRequestDaysFact",
  CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_DURATION: "CanProcessingRequestDays",
  CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_DURATION: "CanProcessingRequestDaysFact",
  CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_BY_CRITERIA_DURATION: "CanProcessingRequestByCriterionDays",
  CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_BY_CRITERIA_DURATION: "CanProcessingRequestByCriterionDaysFact",
  CAN_SEE_PUBLIC_LOT_PLANNED_TENDER_DURATION: 'CanTenderDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_TENDER_DURATION: 'CanTenderDaysFact',
  CAN_SEE_PUBLIC_LOT_PLANNED_SPLITTING_PRICE_DURATION: 'CanDividingPriceDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_SPLITTING_PRICE_DURATION: 'CanDividingPriceDaysFact',
  CAN_SEE_PUBLIC_LOT_PLANNED_WAITING_FOR_FIRST_RETEND_DURATION: 'CanWaitingFirstRetendDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_WAITING_FOR_FIRST_RETEND_DURATION: 'CanWaitingFirstRetendDaysFact',
  CAN_SEE_PUBLIC_LOT_PLANNED_ACCEPT_DURATION: 'CanAcceptDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_ACCEPT_DURATION: 'CanAcceptDaysFact',
  CAN_SEE_PUBLIC_LOT_PLANNED_CONTRACT_CONCLUSION_DURATION: 'CanContractDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_CONTRACT_CONCLUSION_DURATION: 'CanContractDaysFact',
  CAN_SEE_PUBLIC_LOT_PLANNED_RETEND_DURATION: 'CanRetendDays',
  CAN_SEE_PUBLIC_LOT_ACTUAL_RETEND_DURATION: 'CanRetendDaysFact',
  CAN_SEE_PUBLIC_LOT_RETEND: 'CanViewRetend',
  CAN_SEE_PUBLIC_LOT_RETEND_DETAILS: 'CanViewRetendDetails',
  CAN_CREATE_PUBLIC_LOT_RETEND: 'CanCreateRetend',
  CAN_SEE_PUBLIC_LOT_PROTOCOLS: 'CanViewProtocols',
  CAN_SEE_PUBLIC_LOT_MY_REQUEST: 'CanViewRequest',
  CAN_SEE_PUBLIC_LOT_REQUEST_REASON: 'CanViewReason',
  CAN_SEE_PUBLIC_LOT_ALL_REQUESTS: 'CanViewAllRequest',
  CAN_SEE_PUBLIC_LOT_BIDS_HISTORY: 'CanViewAllRequest',
  CAN_SEE_PUBLIC_LOT_CLARIFICATION: 'CanClarificationRequest',
  CAN_VIEW_PUBlIC_LOT_CLARIFICATION: 'CanClarificationView',
  CAN_SEE_PUBLIC_LOT_COMMENTS: 'CanLotComment',
  CAN_SEE_PUBLIC_LOT_REMOVE_BID: 'CanBidDelete',
  CAN_SEE_PUBLIC_LOT_SIGN_REQUEST: 'CanSign',
  CAN_SEE_PUBLIC_LOT_REMOVE_REQUEST: 'CanRequestDelete',
  CAN_SEE_PUBLIC_LOT_REJECT_REQUEST: 'CanRequestReject',
  CAN_SEE_PUBLIC_LOT_CRITERIA_ESTIMATION: 'CanEstimateCriterion',
  CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST: 'CanOrgChangeRequestData',
  CAN_SEE_PUBLIC_LOT_APPROVE_DOCUMENT: 'CanApproveDocument',
  CAN_SEE_PUBLIC_LOT_EDIT_PRICE: 'CanEditPriceCriterion',
  CAN_CHECK_PUBLIC_LOT_REQUEST: 'CanLotViewRequest',
  CAN_ESTIMATE_CRITERION_IN_PUBLIC_LOT: 'CanEstimateCriterion',
  CAN_SEE_PUBLIC_LOT_EDIT_BID_FOR_RETEND: 'CanLotBidRetend',
  CAN_SEE_PUBLIC_LOT_APPEND_DIVIDING_COST_FILE: 'CanDividingPrice',
  CAN_SEE_PUBLIC_LOT_APPROVE_BID: 'CanApproveBid',
  CAN_SEE_PUBLIC_LOT_ACCEPT_BID: 'CanAcceptBid',
  CAN_SEE_PUBLIC_LOT_DOWNLOAD_FINISH_LIST: 'CanGetReductionResult',

  // users
  CAN_BE_BLOCKED: 'CanBlock',
  CAN_BE_UNBLOCKED: 'CanUnblock',
  CAN_BE_ARCHIVED: 'CanArchive',
  CAN_BLOCK_YOURSELF: 'CanSelfBlock',
  CAN_BE_MAIN_ORGANIZER: 'CanSetMainOrganizer',

  // public lot
  SHOULD_BE_SIGNED: 'ShouldBeSigned',
  CAN_BE_SENT_TO_1C: 'CanSend1C',
  CAN_SEE_REDUCTION_TAB: 'CanReductionTab',
  CAN_BACK_TO_RETEND: 'CanUndoAccept',
  CAN_BACK_TO_ACCEPT: 'CanUndoResult',
  CAN_CHANGE_BACK_TO_RETEND: 'CanChangeUndoAccept',
  IS_IN_COMMISSION: 'IsCommission',
  CAN_VIEW_VOTING_RESULTS: 'CanViewOrgVoteData',

  // tenders
  CAN_EDIT_DURATIONS: 'CanEditDurations',
  CAN_EDIT_COMMISSION: 'CanEditCommission',
  CAN_EDIT_CHANGES_IN_TENDER_DESCRIPTION: 'CanChangeDescription',
  CAN_DELETE_TENDER: 'CanDelete',

  // lot
  CAN_DECLINE_APPROVED_LOT: 'CanDecline',
  CAN_REJECT_CANCELLING_LOT: 'LotCancelDecline',
  CAN_ACCEPT_CANCELLING_LOT: 'LotCancelApprove',
  CAN_EDIT_CHANGES_IN_LOT_DESCRIPTION: 'CanChangeDescription',

  // request in public lot
  CAN_ADD_BID: 'CanAddBid',
  CAN_REMOVE_BID: 'CanDeleteBid',
  CAN_REQUEST_CLARIFICATION: 'CanClarification',
  CAN_REMOVE_REQUEST: 'CanDelete',
  CAN_REJECT_REQUEST: 'CanReject',
  HAS_ACCREDITATION: 'IsAccreditate',
  CAN_APPROVE_REQUEST: 'CanApprove',
  CAN_DECLINE_REQUEST: 'CanDecline',
  CAN_CONDITIONALLY_APPROVE_REQUEST: 'CanConditionApprove',
  CAN_NOTIFY_CONDITIONALLY_APPROVED: 'CanDownloadAccessNotice',
  CAN_EDIT_BID_FOR_RETEND: 'CanBidRetend',
  CAN_CHANGE_OWNER: 'CanChangeOwner',
  CAN_EDIT_REQUEST: 'CanEdit',

  // protocol
  CAN_RECOVERY_PROTOCOL: 'CanRecovery',
  CAN_UPLOAD_PROTOCOL: 'CanCreate',
  CAN_DOWNLOAD_PROTOCOL: 'CanDownload',
  CAN_VOTE: 'CanVote',

  // bids
  CAN_EDIT_BID: 'CanEdit',
  CAN_ADJUST_BID: 'CanAdjust',
  CAN_ADD_DIVIDING_COST_FILE: 'CanDividingPrice',
  CAN_ACTIVATE_BID: 'CanActive',
  CAN_DECLINE_BID: 'CanDecline',
  CAN_ACCEPT_BID: 'CanAccept',
  CAN_DOWNLOAD_ACCEPT: 'CanSendAccept',
  CAN_EDIT_EXTRA_COST: 'CanExtraNomen',
  CAN_ATTACH_RESULT_FILE: 'CanAttachStateFile',

  // specification in bids
  CAN_APPROVE_SPEC_POSITION_IN_BID: 'CanApprove',
  CAN_DECLINE_SPEC_POSITION_IN_BID: 'CanDecline',
  CAN_CHANGE_NOMEN_IN_SPEC_POSITION_IN_BID: 'CanSetNomen',

  // criteria in bid
  CAN_EDIT_CRITERIA: 'CanEdit',
  CAN_EDIT_CRITERIA_ESTIMATION: 'CanEstimate',
  CAN_ADJUST_CRITERIA: 'CanAdjust',
  CAN_APPROVE_CRITERIA_DOCUMENT: 'CanApproveDocument',

  // documents
  CAN_EDIT_DOCUMENT: 'CanEdit',
  CAN_APPROVE_DOCUMENT: 'CanApprove',
  CAN_ADJUST_DOCUMENT: 'CanAdjust',

  // clarification
  CAN_ANSWER_CLARIFICATION: 'CanAnswer',

  // discussion
  CAN_EDIT_DISCUSSION: 'CanEdit',

  // retend
  CAN_EDIT_RETEND: 'CanEdit',
  CAN_APPROVE_RETEND: 'CanApprove',
  CAN_ACCEPT_RETEND: 'CanAccept',
  CAN_CANCEL_ACTIVE_RETEND: 'CanCancel',
  CAN_EDIT_ACTIVE_RETEND: 'CanDraft',
  CAN_CHANGE_RETEND_DURATION: 'CanDuration',

  // news
  CAN_EDIT_NEWS: 'UserAdminNews'
};

export default {
  init(values) {
    let result = {};
    if (!values) values = [];
    Object.keys(PERMISSIONS).map(p => { result[p] = values.indexOf(PERMISSIONS[p]) !== -1 });
    return result;
  }
}
